export { fetchAPI } from './rest/fetchMethod'
export * from './graphql'
